// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.
import { createSelector } from 'reselect'

import { fullSystemStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../types/system').SystemPermission} SystemPermission
 * @typedef {import('../types/system').FilePermission} FilePermission
 */

// FIXME: we should eliminate this key and use project only.
// Currently both reducers listen to the "selectFile" action
/**
 * @type {function(PlottrState): SystemPermission}
 */
const fullPermissionSelector = createSelector(fullSystemStateSelector, ({ permission }) => {
  return (
    permission ?? {
      permission: null,
    }
  )
})
/**
 * @type {function(PlottrState): FilePermission | Null}
 */
export const permissionSelector = createSelector(
  fullPermissionSelector,
  ({ permission }) => permission ?? null
)
/**
 * @type {function(PlottrState): boolean}
 */
export const canReadSelector = createSelector(
  permissionSelector,
  (permission) => permission === 'owner' || permission === 'collaborator' || permission === 'viewer'
)
/**
 * @type {function(PlottrState): boolean}
 */
export const canWriteSelector = createSelector(
  permissionSelector,
  (permission) => permission === 'owner' || permission === 'collaborator'
)
/**
 * @type {function(PlottrState): boolean}
 */
export const canAdministrateSelector = createSelector(
  permissionSelector,
  (permission) => permission === 'owner'
)
